import React from 'react'

export default function HeaderFutureMineralsPricesLoading() {
  return (
    <div className="flex h-[68px] w-full overflow-hidden bg-white">
      {[...Array(12)].map((_, i) => (
        <div
          key={i}
          className="after:bg-muted-300 flex h-full !w-[200px] animate-pulse bg-light after:my-auto after:flex after:h-10 after:w-[2px]"
        />
      ))}
    </div>
  )
}
